import { IconPaths, ModalSize, TipoReceitaSncr } from '_metronic/helpers'
import { useT } from '_metronic/i18n/Metronici18n'
import { Button, useModal } from 'app/components'
import { SncrLocalizarNumeroModal } from '../../components/SncrLocalizarNumeroModal'
import { SncrNotificacoesLista } from '../../components/SncrNotificacoesLista'
import { SncrSaldoCard } from '../../components/SncrSaldoCard'
import { isNotificacaoSncr } from '../../core/_models'
import { useSncr, useSncrContexto } from '../../hooks/useSncr'
import { useListFilters } from '../core/ListFiltersProvider'
import { useQueryResponse } from '../core/QueryResponseProvider'
import { SncrBlocosSearchComponent } from './SncrBlocosSearchComponent'

/**
 * Seletor de empresa (quando faz diferença), um card por tipo de bloco (RCE/RET) com a reserva, a
 * situação e a retirada, a lista compacta das notificações, e o localizador de número acima da tabela.
 */
export const SncrBlocosHeader = () => {
  const { t } = useT()
  const { showModal } = useModal()
  const { filters } = useListFilters()
  const { refetch } = useQueryResponse()
  const { showRetiradaModal } = useSncr()

  const idEmpresa = filters.empresa?.value
  const { data: contexto, refetch: refetchContexto } = useSncrContexto(idEmpresa)

  const retirar = async (tipo: TipoReceitaSncr) => {
    if (!idEmpresa || !contexto) return
    const resultado = await showRetiradaModal(idEmpresa, tipo, contexto)
    if (resultado) {
      refetchContexto()
      refetch()
    }
  }

  // Localizador: responde "em qual receita minha este número foi usado" (pergunta de farmácia/Visa).
  const abrirLocalizador = () =>
    showModal({
      title: t('sncr.localizar.rotulo'),
      size: ModalSize.Large,
      content: <SncrLocalizarNumeroModal />,
    })

  return (
    <div className='card-header border-0 pt-6'>
      <div className='w-100 d-flex flex-column gap-6'>
        <p className='text-gray-700 mb-0'>{t('sncr.lista.intro')}</p>

        <SncrBlocosSearchComponent />

        {contexto && (
          <>
            <section aria-labelledby='sncr-blocos-titulo'>
              <h3 id='sncr-blocos-titulo' className='fs-5 fw-bold text-gray-900 mb-3'>
                {t('sncr.blocos.titulo')}
              </h3>
              <div className='row g-4' role='group' aria-label={t('sncr.lista.cards_aria')}>
                {contexto.saldos
                  .filter((saldo) => !isNotificacaoSncr(saldo.tipo))
                  .map((saldo) => (
                    <div key={saldo.tipo} className='col-lg-6'>
                      <SncrSaldoCard
                        saldo={saldo}
                        habilitado={contexto.habilitado}
                        onRetirar={retirar}
                      />
                    </div>
                  ))}
              </div>
              <p className='text-gray-700 fs-7 mt-4 mb-0'>
                {t('sncr.lista.reserva_info')}{' '}
                {t('sncr.lista.limite_info', { limite: contexto.limiteBlocosMes })}
              </p>
            </section>

            <SncrNotificacoesLista
              saldos={contexto.saldos.filter((saldo) => isNotificacaoSncr(saldo.tipo))}
              habilitado={contexto.habilitado}
              onRetirar={retirar}
            />

            {/* Título da tabela com a ação que é sobre ela: localizar um número dos blocos. */}
            <div className='d-flex justify-content-between align-items-center flex-wrap gap-3'>
              <h3 className='fs-5 fw-bold text-gray-900 mb-0'>{t('sncr.lista.blocos_titulo')}</h3>
              <Button
                variant='secondary-outline'
                icon={IconPaths.Search}
                onClick={abrirLocalizador}
              >
                {t('sncr.localizar.rotulo')}
              </Button>
            </div>
          </>
        )}
      </div>
    </div>
  )
}
